import { AxiosError } from "axios";
import findIndex from "lodash/findIndex";
import mapKeys from "lodash/mapKeys";
import omitBy from "lodash/omitBy";
import { BookingDataItem, BookingFormMode } from "PFApp/booking/components/booking_form/booking_form.types";

const remapErrorsToBookings = (
  responseErrors: Record<string, string>,
  bookingsToSend: { id: number }[],
  bookings: { id: number }[]
) => {
  const remapped = mapKeys(responseErrors, (value, key) => {
    const match = key.match(/^bookings\[(\d+)\]\[(.+)\]$/);
    if (!match) {
      return key;
    }
    const [, index, field] = match;
    const resultIndex = findIndex(bookings, { id: bookingsToSend[index]?.id });
    return `bookings[${resultIndex}][${field}]`;
  });

  return omitBy(remapped, (value, key) => key.includes("[-1]"));
};

export const getRemappedErrors = (
  error: AxiosError,
  mode: BookingFormMode,
  responseErrors: Record<string, string>,
  bookings: BookingDataItem[]
) => {
  const isCreatingMode = [
    BookingFormMode.Create,
    BookingFormMode.CloneSingle,
    BookingFormMode.CloneAll
  ].includes(mode);
  if (isCreatingMode) {
    return responseErrors;
  }
  const bookingsRequested = JSON.parse(error.config?.data ?? "{}").bookings;
  return remapErrorsToBookings(responseErrors, bookingsRequested, bookings as { id: number }[]); // id is always present for editing
};
